import { IconDefinition } from "./types";

const fireFlameCurved: IconDefinition = {
  iconName: "fire-flame-curved",
  width: 384,
  height: 512,
  svgPathData:
    "M72 192.1C26.9 224.4 0 276.5 0 332.2 0 431.5 80.5 512 179.8 512l21.8 0c100.8 0 182.5-81.7 182.5-182.5 0-67.2-28.4-131.3-78.1-176.5L223.7 78.3c-5.3-4.8-9.4-10.8-12.1-17.3-2.4-5.7-3.6-11.9-3.6-18.3L208 0 178.9 25.9c-5.8 5.2-11.1 10.8-15.8 16.9-1 1.3-2 2.6-3 3.9-9.2 12.7-15.9 27-19.9 42.1-2.8 10.5-4.2 21.4-4.2 32.5 0 27 8.5 51.4 21.4 70.8 5 7.5 16.1 24.2 33.3 49.9 6.1 9.1 9.3 19.7 9.3 30.7l0 15.3c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-128c-16.2 10.8-30.6 20.4-43.3 28.9-1.6 1.1-3.2 2.2-4.7 3.3zm0 66.7L72 288c0 48.6 39.4 88 88 88s88-39.4 88-88l0-15.3c0-20.4-6-40.3-17.3-57.3l-33.3-49.9c-8.7-13.1-13.4-28.5-13.4-44.2 0-4.6 .4-9.2 1.2-13.7 2 2.2 4 4.2 6.2 6.2l82.2 74.7c39.7 36.1 62.4 87.3 62.4 141 0 74.3-60.2 134.5-134.5 134.5l-21.8 0C107 464 48 405 48 332.2 48 305.4 56.6 279.8 72 258.8z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "fire-flame-curved",
  unicode: 0xf7e4,
};

export { fireFlameCurved };
